import * as React from "react"
import { Create } from "react-admin"
import {
  TextInputCss,
  TextInputFullCss,
  SimpleFormWidth,
  TwoInput,
} from "../../utils/styled"
import { required } from "../../utils/validate"

export const ConsumerCreate = (props: any) => (
  <Create {...props}>
    <SimpleFormWidth>
      <TwoInput>
        <TextInputCss
          fullWidth
          source="pmsPatientID"
          label=" Patient ID"
          required={true}
          validate={required()}
        />
        <TextInputCss
          fullWidth
          source="patientTitle"
          label="Patient Title"
          required={true}
          validate={required()}
        />
      </TwoInput>
      <TwoInput>
        <TextInputCss
          fullWidth
          source="patientFirstName"
          label="First Name"
          required={true}
          validate={required()}
        />
        <TextInputCss
          fullWidth
          source="patientLastName"
          label="Last Name"
          required={true}
          validate={required()}
        />
      </TwoInput>
      <TwoInput>
        <TextInputCss
          fullWidth
          source="patientDOB"
          label=" Patient DOB"
          required={true}
          validate={required()}
        />
        <TextInputCss
          fullWidth
          source="patientGender"
          label="Gender"
          required={true}
          validate={required()}
        />
      </TwoInput>
      <TwoInput>
        <TextInputCss
          fullWidth
          source="patientHomeNum"
          label="Home Number"
          required={true}
          validate={required()}
        />
        <TextInputCss
          fullWidth
          source="patientWorkNum"
          label="Work Number"
          required={true}
          validate={required()}
        />
      </TwoInput>
      <TwoInput>
        <TextInputCss
          fullWidth
          source="patientCellNum"
          label="Cell Number"
          required={true}
          validate={required()}
        />
        <TextInputCss
          fullWidth
          source="patientEmail"
          label="Patient Email"
          required={true}
          validate={required()}
        />
      </TwoInput>
      <TextInputFullCss
        fullWidth
        source="patientAddress1"
        label="Address 1"
        required={true}
        validate={required()}
      />
      <TextInputFullCss
        fullWidth
        source="patientAddress2"
        label="Address 2"
        required={true}
        validate={required()}
      />
      <TwoInput>
        <TextInputCss
          fullWidth
          source="patientCity"
          label="City"
          required={true}
          validate={required()}
        />
        <TextInputCss
          fullWidth
          source="patientState"
          label="State"
          required={true}
          validate={required()}
        />
      </TwoInput>
      <TwoInput>
        <TextInputCss
          fullWidth
          source="patientZip"
          label="Zip"
          required={true}
          validate={required()}
        />
        <TextInputCss
          fullWidth
          source="patientLastVisitOrExamDate"
          label="Last Visit Or ExamDate"
          required={true}
          validate={required()}
        />
      </TwoInput>
      <TwoInput>
        <TextInputCss
          fullWidth
          source="providerID"
          label="Provider ID"
          required={true}
          validate={required()}
        />
        <TextInputCss
          fullWidth
          source="locationID"
          label="Location ID"
          required={true}
          validate={required()}
        />
      </TwoInput>
      <TwoInput>
        <TextInputCss
          fullWidth
          source="smsPreference"
          label="Preference"
          required={true}
        />
        <TextInputCss
          fullWidth
          source="emailPreference"
          label="Email Preference"
          required={true}
          validate={required()}
        />
      </TwoInput>
      <TwoInput>
        <TextInputCss
          fullWidth
          source="voicePreference"
          label="Voice Preference"
          required={true}
          validate={required()}
        />
        <TextInputCss
          fullWidth
          source="postalPreference"
          label="Postal Preference"
          required={true}
          validate={required()}
        />
      </TwoInput>
      {/* <CustomReferenceInputCss
        fullWidth
        label="Store"
        source="storeID"
        reference="stores"
        allowEmpty={false}
        perPage={0}
      >
        <CustomSelectInput optionText="storeName" />
      </CustomReferenceInputCss> */}
    </SimpleFormWidth>
  </Create>
)
